import styled from "styled-components";
import RichTextEditor from 'react-rte';
import { Button } from "react-bootstrap";

export const EditorWrapper = styled(RichTextEditor)`
    height: 250px;

    // div.forward-editor {
    //     font-family: Arial;
    // }

    & > div[class^="RichTextEditor__editor"] {
        height: 196px;
        font-family: Arial;
    }
    
    & button {
        border-color: #ccc;
    }

    & span {
        border-color: #ccc;
    }
`;

export const LinkButtonWrapper = styled(Button)`
    :focus {
        outline: 0 none !important;
    }

    padding: 5px 0px 0px 0px;
`;


export const ValueWrapper = styled.div`
    height: 34px;
    padding: 6px 12px;
    background-color: #E7E6E6;
    border: 1px solid #ccc;
    border-radius: 4px;
    cursor: not-allowed;
    font-size: 14px;
    line-height: 1.42857143;
`;

export const DetailWrapper = styled.div`
`;
